/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from '@material-ui/core/StepConnector';
import ArrivedGift from '../assets/svg/ArrivedGift';
import { getDataDictionary } from '../../../../state/ducks/App/App-Selectors';
import { getBrand } from '../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getLanguageName } from '../../../../state/ducks/Member/ducks/Auth/helper/helper';

const stylesStepIcon = (theme) => ({
    root: {
        display: 'flex',
        height: 32,
        alignItems: 'center',
    },
    active: {
        color: theme.palette.colorPrimary,
    },
    circle: {
        width: 30,
        height: 30,
        borderRadius: '50%',
        border: `2px solid ${theme.palette.colorPrimary}`,
    },
    completed: {
        color: theme.palette.colorPrimary,
        zIndex: 1,
        width: 30,
        height: 30,
        borderRadius: '50%',
        border: `2px solid ${theme.palette.colorPrimary}`,
        backgroundColor: theme.palette.colorPrimary,
        padding: '4px',
        backgroundClip: 'content-box',
    },
});

const stylesStepIconPlants = (theme) => ({
    root: {
        display: 'flex',
        height: 32,
        alignItems: 'center',
    },
    active: {
        color: theme.palette.colorPrimary,
    },
    circle: {
        width: 30,
        height: 30,
        borderRadius: '50%',
        border: `2px solid ${theme.palette.colorPrimary}`,
    },
    completed: {
        color: theme.palette.colorPrimary,
        zIndex: 1,
        width: 30,
        height: 30,
        borderRadius: '50%',
        border: `2px solid ${theme.palette.colorPrimary}`,
        backgroundColor: theme.palette.colorPrimary,
        padding: '4px',
        backgroundClip: 'content-box',
    },
});

const stylesConnector = (theme) => ({
    alternativeLabel: {
        top: 13,
        left: 'calc(-50% + 14px)',
        right: 'calc(50% + 13px)',
    },
    line: {
        borderColor: theme.palette.colorPrimary,
        borderTopWidth: 2,
        borderRadius: 1,
    },
});

const stylesConnectorPlants = (theme) => ({
    alternativeLabel: {
        top: 13,
        left: 'calc(-50% + 14px)',
        right: 'calc(50% + 13px)',
    },
    line: {
        borderColor: theme.palette.colorPrimary,
        borderTopWidth: 2,
        borderRadius: 1,
    },
});

const Connector = withStyles(stylesConnector)(StepConnector);
const ConnectorPlants = withStyles(stylesConnectorPlants)(StepConnector);

const StepIcon = withStyles(stylesStepIcon)((props) => {
    const { active, completed, classes } = props;

    return (
        <div
            className={`${classes.root} ${{
                [classes.active]: active,
            }}`}
        >
            {completed ? <div className={classes.completed} /> : <div className={classes.circle} />}
        </div>
    );
});

const StepIconPlants = withStyles(stylesStepIconPlants)((props) => {
    const { active, completed, classes } = props;

    return (
        <div
            className={`${classes.root} ${{
                [classes.active]: active,
            }}`}
        >
            {completed ? <div className={classes.completed} /> : <div className={classes.circle} />}
        </div>
    );
});

StepIcon.propTypes = {
    active: PropTypes.bool.isRequired,
    completed: PropTypes.bool.isRequired,
};

const StatusTracking = (props) => {
    const {
        status, brand, trackingMobile, dataDictionary,
    } = props;
    let orderStatus = 1;
    switch (status) {
        case 'I':
        case 'IN TRANSIT':
            orderStatus = 2;
            break;
        case 'D':
        case 'DELIVERED':
        case 'U':
            orderStatus = 3;
            break;
        case 'C':
            orderStatus = 0;
            break;
        default:
            orderStatus = 1;
    }

    const language = getLanguageName();
    const stepsTranslations = {
        orderPlaced: language === '/en' ? 'Order Placed' : dataDictionary?.['Order Placed'] || 'Order Placed',
        inTransit: language === '/en' ? 'In Transit' : dataDictionary?.['In Transit'] || 'In Transit',
        delivered: language === '/en' ? 'Delivered' : dataDictionary?.['Delivered'] || 'Delivered',
        cancelled: language === '/en' ? 'Cancelled' : dataDictionary?.['Cancelled'] || 'Cancelled',
    };
    let steps = [stepsTranslations.orderPlaced, stepsTranslations.inTransit, stepsTranslations.delivered];
    if (orderStatus === 0) {
        steps = ['', stepsTranslations.cancelled, ''];
    }
    let stepClasses = '';
    steps.forEach((s, i) => {
        if (i < orderStatus) {
            stepClasses += ['step-', i + 1, ' '].join('');
        }
    });
    if (orderStatus === 0) {
        stepClasses = 'step-0';
    }

    let activeClass = '';
    if (!trackingMobile && orderStatus === 0) {
        activeClass = 'mobileStatusTracking';
    } else if (!trackingMobile) {
        activeClass = 'desktopStatusTracking';
    } else {
        activeClass = 'mobileStatusTracking';
    }
    const alternativeLabel = activeClass === 'desktopStatusTracking';

    return (
        <>
            {!['PLA', '08F', 'CAN'].includes(brand.code) && (
                <div className={`statusTrackingBar margin-top ${stepClasses}`}>
                    {steps.map((step, i) => (
                        <div key={['_', i].join('')} className="step">
                            <div className="h2">{step}</div>
                        </div>
                    ))}
                    {orderStatus === 3 && (
                        <div className="arrivedGift">
                            <ArrivedGift />
                        </div>
                    )}
                </div>
            )}
            {['PLA', '08F', 'CAN'].includes(brand.code)
                && (
                    <div className={activeClass}>
                        <Stepper alternativeLabel={alternativeLabel} activeStep={orderStatus} connector={brand.code === 'PLA' ? <ConnectorPlants /> : <Connector />}>
                            {steps.map((label) => (
                                <Step key={label}>
                                    <StepLabel StepIconComponent={brand.code === 'PLA' ? StepIconPlants : StepIcon}>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </div>
                )}
        </>
    );
};

StatusTracking.defaultProps = {
    status: '',
    brand: {},
    trackingMobile: false,
    dataDictionary: {},
};

StatusTracking.propTypes = {
    status: PropTypes.string,
    brand: PropTypes.object,
    trackingMobile: PropTypes.bool,
    dataDictionary: PropTypes.object,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
    dataDictionary: getDataDictionary(state),
});
export default connect(mapStateToProps)(StatusTracking);
